// extracted by mini-css-extract-plugin
export default {"Appearance":"Appearance_Appearance__WVjnf","title":"Appearance_title__-rUes"};